module.exports = __webpack_public_path__ + "img/Sleeves-Front-Gd-Ha-Ia.5eb32e88.png";